import React, { useMemo, useState } from 'react';
import { PDFPreview } from '../../../../../../ui-toolkit/components/PDFPreview';
import { IncomingDocumentsTable } from './Incoming/IncomingDocumentsTable';
import { OutgoingDocumentsTable } from './Outgoing/OutgoingDocumentsTable';
import _ from 'lodash';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { Show } from '../../../../../shared/Show';

export const AppointmentDocumentsTab: React.FC = () => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const [previewDoc, setPreviewDoc] = useState<string | null>(null);
  const [incomingDocs, outgoingDocs] = useMemo(
    () =>
      _(appointmentFromPath?.documents ?? [])
        .partition(({ isIncoming }) => isIncoming)
        .value(),
    [appointmentFromPath]
  );

  return (
    <>
      {previewDoc && <PDFPreview file={previewDoc} onClose={() => setPreviewDoc(null)} />}
      <div className="space-y-4 pt-4" data-test-id="outgoing-documents">
        <OutgoingDocumentsTable outgoingDocs={outgoingDocs} setPreviewDoc={setPreviewDoc} />
        <Show when={!!appointmentFromPath?.isSignatureSyncAppointment}>
          <IncomingDocumentsTable
            incomingDocs={incomingDocs}
            setPreviewDoc={setPreviewDoc}
            manifest={appointmentFromPath?.scanbackManifest}
          />
        </Show>
      </div>
    </>
  );
};
